<template>
  <div id="AccordionMenu" class="text-NotoSansRegular">
    <aside>
      <!-- 最新優惠 -->
      <div class="sale py-2" v-if="$route.name !== 'download' && events && events.length > 0">
        <h6 class="sale-title px-4 text-NotoSansBold mb-1 textColorBlack text-sm tracking-wider">最新優惠</h6>
        <ul class="sale-ul textColorBlack">
          <li v-for="(item, index) in events" :key="index" class="sale-li">
            <router-link :to="{ name: 'sale', params: { category: category }, query: { tag: item.id } }"
              class="sale-aLink justify-between block pb-1 px-4 text-NotoSansLight cursor-pointer py-1 tracking-wide">
              <p class="sale-aLink-name m-0 text-name text-sm whitespace-pre-wrap">
                <img style="height: 7px;" src="~@/assets/icon/sidenav_list_icon.gif" class="object-contain inline-block pr-2">{{ item.name }}</p>
            </router-link>
          </li>
        </ul>
      </div>
      <!-- 最新優惠 -->

      <!-- 選單 -->
      <ul id="AccordionMenu-main-menu" class="main-menu" v-if="(menuData !== null || textList !== null) && $route.params.category !== 'recent'">

        <li class="main-menu-li" v-for="(item, index) in returnData" :key="index" ref="title">

          <a class="main-menu-li-a justify-between block py-3 px-4 lg:py-3 tracking-wider"
            @click.prevent="firstMenu(index, item)">
            <p class="m-0 text-name text-sm">{{ item.title }}</p>
          </a>

          <ul class="main-menu-child-ul" ref="items">
            <li v-for="child in item.items" :key="child.name" class="main-menu-child-ul-li">
              <!-- 雜誌介紹 -->
              <router-link :to="{ name: 'magazineIntro', params: { class: child.scope } }" @click.prevent="secondMenu(child)" v-if="child.type === 'INTRO'"
                class="main-menu-child-ul-li-a w-full h-full block py-2 text-sm bg-white overflow-hidden tracking-wider px-4">{{ child.title }}
              </router-link>
              <!-- 其他 -->
              <a @click.prevent="secondMenu(child)" v-if="child.type !== 'INTRO'"
                class="main-menu-child-ul-li-a w-full h-full block py-2 text-sm bg-white overflow-hidden tracking-wider px-4">{{ child.title }}
              </a>
            </li>
          </ul>

        </li>

        <!-- 點讀館 -->
        <li class="main-menu-li" v-if="$route.params.category === 'livepen'">
          <router-link :to="{ name: 'download' }" class="main-menu-li-a justify-between block py-3 px-4 lg:py-3 tracking-wider">
            <p class="m-0 text-name text-sm">點讀音檔下載</p>
          </router-link>
        </li>
        <li class="main-menu-li" v-if="$route.params.category === 'livepen'">
          <a href="https://docs.google.com/forms/d/1xKbpsJpT1ECtrUYZKq153YmzL7fSDckn9VHHNmH9UHY/viewform?edit_requested=true" target="_blank" class="main-menu-li-a justify-between block py-3 px-4 lg:py-3 tracking-wider">
            <p class="m-0 text-name text-sm">線上保固卡填寫</p>
          </a>
        </li>
        <!-- 點讀館 -->

        <!-- 數位學習 -->
        <li class="main-menu-li" v-if="$route.params.category === 'digital'">
          <router-link :to="{ name: 'productsList', params: { category: 'digital' }, query: { digiType: 'APP' } }" class="main-menu-li-a justify-between block py-3 px-4 lg:py-3 tracking-wider">
            <p class="m-0 text-name text-sm">APP學習</p>
          </router-link>
        </li>
        <li class="main-menu-li" v-if="$route.params.category === 'digital'">
          <router-link :to="{ name: 'productsList', params: { category: 'digital' }, query: { digiType: 'EBOOK' } }" class="main-menu-li-a justify-between block py-3 px-4 lg:py-3 tracking-wider">
            <p class="m-0 text-name text-sm">電子書</p>
          </router-link>
        </li>
        <!-- 數位學習 -->

        <!-- flash -->
        <li class="main-menu-li" v-if="$route.name === 'download'">
          <p class="leading-relaxed font-medium justify-between block py-2 px-4 lg:py-2 lg:px-5 text-sm m-2 textColorRed border borderRed">Flash Player將自2021/1/12停用，若未移除將造成互動學習軟體無法使用，請連結至QA下載移除說明
            <router-link :to="{ name: 'service', params: { id: 'flash' } }" class="text-blue-500 underline">（請點我）
            </router-link></p>
        </li>
        <!-- flash -->

      </ul>
      <!-- 選單 -->
    </aside>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */
import axios from 'axios'
import Bus from '@/components/modules/bus.js'
export default {
  name: 'AccordionMenu',
  data () {
    return {
      events: null,
      textList: null,
      menuData: null,
      category: 'book'
    }
  },
  watch: {
    '$route.params.id': {
      async handler (newVal, oldVal) {
        if (newVal && (newVal !== oldVal) && this.$route.name !== 'download') {
          await this.getType()
        }
      }
    },
    '$route.params.category': {
      async handler (newVal, oldVal) {
        if (newVal && (newVal !== oldVal) && this.$route.name !== 'download') {
          await this.getData()
        }
      }
    },
    '$route.name': {
      async handler (newVal, oldVal) {
        if (newVal && (newVal !== oldVal)) {
          await this.getData()
        }
      }
    }
  },
  computed: {
    returnData () {
      if (this.$route.name !== 'download') {
        return this.textList.items
      } else {
        return this.menuData
      }
    }
  },
  async mounted () {
    await this.getEvents()
    // await this.getData()
    this.getType()
  },
  methods: {
    async getType () {
      let self = this
      if (self.$route.params.category || (self.$route.name === 'magazine' || self.$route.name === 'magazineIntro' || self.$route.name === 'download')) {
        this.getData()
      } else {
        console.log(self.$route.params.category)
        var path = '/menu/book'
        Bus.$on('val', (val) => {
          switch (val) {
            case 'BOOK':
              path = '/menu/book'
              self.category = 'book'
              break
            case 'MAGAZINE':
              path = '/menu/magazine'
              self.category = 'magazine'
              break
            case 'PLAN':
              path = '/menu/magazine'
              self.category = 'magazine'
              break
            case 'PACKAGE':
              path = '/menu/package'
              self.category = 'package'
              break
            case 'DIGITAL':
              path = '/menu/digital'
              self.category = 'digital'
              break
            case 'LIVEPEN':
              path = '/menu/livepen'
              self.category = 'livepen'
              break
          }
        })

        let { data } = await axios.get(path)
        self.textList = data.menu
      }
    },
    async getData () {
      let self = this
      if (self.$route.name === 'productsList' || self.$route.name === 'sale' || self.$route.name === 'detail' || self.$route.name === 'previewMagazine') {
        let path
        switch (self.$route.params.category) {
          case 'recent':
            path = '/menu/newbook'
            self.category = 'recent'
            break
          case 'magazine':
            path = '/menu/magazine'
            self.category = 'magazine'
            break
          case 'book':
            path = '/menu/book'
            self.category = 'book'
            break
          case 'package':
            path = '/menu/package'
            self.category = 'package'
            break
          case 'digital':
            path = '/menu/digital'
            self.category = 'digital'
            break
          case 'livepen':
            path = '/menu/livepen'
            self.category = 'livepen'
            break
        }
        let { data } = await axios.get(path)
        self.textList = data.menu
      } else if (self.$route.name === 'magazine' || self.$route.name === 'magazineIntro') {
        let { data } = await axios.get('/menu/magazine')
        self.textList = data.menu
        self.category = 'magazine'
      } else if (self.$route.name === 'download') {
        let { data } = await axios.get('/menu/downloads')
        self.menuData = data.menu
        self.category = 'downloads'
      }
    },

    firstMenu (index, item) {
      // 第一層
      let self = this
      if (self.$route.params.category === 'book') {
        let obj = { name: 'productsList', params: { category: 'book' }, query: {} }
        item.type ? obj.query.type = 'BOOK,' + item.type : obj.query.type = 'BOOK'
        item.category_id ? obj.query.category = item.category_id : null
        self.$router.push(obj)
      }
      if (self.$route.params.category === 'recent') {
        self.$router.push({ name: 'productsList', params: { category: 'recent' }, query: { scope: item.scope } })
      }
      if (self.$route.params.category === 'package' && item.type === 'ITEM') {
        self.$router.push({ name: 'productsList', params: { category: self.$route.params.category }, query: { type: item.type, category: item.category_id, scope: item.scope } })
      }
      if (self.$route.params.category === 'livepen' && !item.items) {
        self.$router.push({ name: 'productsList', params: { category: self.$route.params.category }, query: { type: item.type, category: item.category_id, scope: item.scope } })
      }
    },
    secondMenu (item) {
      // 第二層
      let self = this
      if (self.$route.name === 'download') {
        let queryObj = {}

        if (item.type) {
          queryObj.type = 'BOOK,' + item.type
        }

        if (item.category_id) {
          queryObj.category = item.category_id
        }

        self.$router.push({ name: 'download', query: queryObj })
      } else {
        let queryObj = {}

        if (item.type) {
          queryObj.type = item.type
        }

        if (item.category_id) {
          queryObj.category = item.category_id
        }

        if (item.scope) {
          queryObj.scope = item.scope
        }

        self.$router.push({ name: 'productsList', params: { category: self.category }, query: queryObj })
      }
    },
    toSale (id) {
      let self = this
      self.$router.push({ name: 'sale', params: { category: self.category }, query: { tag: id } })
    },
    getEvents () {
      let self = this
      // let listPath = '/promote_events?type=specific'
      let listPath = '/promote_events'

      axios.get(listPath)
        .then((response) => {
          self.events = response.data.data
        })
    }
  }
}
</script>
<style lang="scss" scoped>
  #AccordionMenu {
    aside {
      overflow: auto;
      .sale {
        ul {
          li {
            .sale-aLink {
              &:hover {
                color: #7f7f7f !important;
              }
            }
          }
        }
      }
      .main-menu {
        .main-menu-li {
          color : #2C3E50;
          background : #FFFFFF;
          font-size : 16px;
          font-weight : 600;
          text-transform : capitalize;
          position: relative;
          .main-menu-li-a {
            cursor : pointer;
            .text-name {
              color: #434343;
            }
          }
          .main-menu-child-ul {
            transition: .3s;
            overflow: hidden;
            padding-left : 0;
            list-style : none;
            .main-menu-child-ul-li {
              background : rgb(255, 255, 255);
              color : #434343;
              font-weight : 600;
              transition: all .4s ease;
              -webkit-transition: all .4s ease;
              -moz-transition : all .4s ease;
              .main-menu-child-ul-li-a {
                display: block;
                font-weight: 400;
                color: #2C3E50;
                &:hover {
                  cursor : pointer;
                  opacity: 0.8;
                }
              }
              &:last-child {
                border : none;
              }
            }
          }
        }
      }
    }
  }
</style>
